module.exports = DragonShared.React;